export const sectionExtensionType = 'com.atlassian.confluence.section';
